import React, { useState } from 'react';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Tooltip from '@mui/material/Tooltip';
import Divider from '@mui/material/Divider';

import {
  FormGroup,
  InputLabel,
  FormHelperText,
  Typography,
  Stack,
} from '@mui/material';
import { Input } from '@mui/material';
import { Select } from '@mui/material';
import { MenuItem } from '@mui/material';

import Draggable from 'react-draggable';

import { useSelector, useDispatch } from 'react-redux';

import { uploadVektor, downloadVektor } from '../../redux/actions/export';
import { fontWeight } from '@mui/system';

import { innerColor, themeColor } from '../../constants/themes';

const DataImpExpUtil = (props) => {
  const map = props.basemap;
  const dispatch = useDispatch();

  const visibleData = props.visible;
  const setVisibleData = props.visibleFunc;

  const [layer, setLayer] = useState(null);
  const [format, setFormat] = useState('');
  const [form, setForm] = useState('');
  const [downloadLayer, setDownloadLayer] = useState('');

  let layerFeatureList = useSelector((state) => state.layersFeature);

  const handleLayer = (event) => {
    setDownloadLayer(event.target.value);
    layerFeatureList.map((layer) => {
      if (layer.get('title') === event.target.value) {
        setLayer(layer);
      }
    });
  };

  const handleFile = (form) => {
    setForm(form);
  };

  const handleFormat = (event) => {
    setFormat(event.target.value);
  };

  const uploadFile = () => {
    dispatch(uploadVektor(form, map, format));
  };

  const downloadFile = (format) => {
    dispatch(downloadVektor(format, layer));
  };
  return (
    <Draggable>
      <Card
        sx={{
          position: 'absolute',
          marginRight: '4em',
          zIndex: 1,
          display: visibleData,
        }}
      >
        <CardHeader
          sx={{
            color: innerColor,
            backgroundColor: themeColor,
          }}
          title="Vektör Veri Yükleme/İndirme"
          titleTypographyProps={{ variant: 'h6' }}
          action={
            <IconButton
              sx={{ backgroundColor: 'grey' }}
              onClick={() => setVisibleData('none')}
            >
              <CloseIcon />
            </IconButton>
          }
        />
        <CardContent
          style={{
            width: '25em',
            display: 'flex',
            flexDirection: 'column',
            padding: '1em',
          }}
        >
          <FormGroup style={{ backgroundColor: 'white' }}>
            <Stack spacing={2}>
              <Stack>
                <Stack direction="row" spacing={1}>
                  <i className="fg-layer-upload fg-2x"></i>
                  <Typography
                    style={{
                      fontWeight: 'bold',
                      marginTop: '.8em',
                    }}
                  >
                    Veri Yükleme
                  </Typography>
                </Stack>
                <Input
                  type="file"
                  id="uploadFile"
                  aria-describedby="my-helper-text"
                  onChange={handleFile}
                />
                <FormHelperText id="my-helper-text">
                  Yüklemek istediğiniz dosyayı seçiniz
                </FormHelperText>
                <InputLabel id="selectFileFormat">Dosya Formatı</InputLabel>
                <Select
                  labelId="selectFileFormat"
                  id="selectFileFormat"
                  value={format}
                  label="Format"
                  onChange={handleFormat}
                  style={{ marginBottom: '5px' }}
                >
                  <MenuItem value={'esrijson'}>EsriJSON</MenuItem>
                  <MenuItem value={'geojson'}>GeoJSON</MenuItem>
                  <MenuItem value={'gpx'}>GPX</MenuItem>
                  <MenuItem value={'kml'}>KML</MenuItem>
                  <MenuItem value={'shapefile'}>ShapeFile</MenuItem>
                  <MenuItem value={'topojson'}>TopoJSON</MenuItem>
                </Select>
                <Button onClick={uploadFile} variant="contained">
                  Dosya Yükle
                </Button>
              </Stack>
              <Divider />
              <Stack>
                <Stack direction="row" spacing={1}>
                  <i className="fg-layer-download fg-2x"></i>
                  <Typography
                    style={{
                      fontWeight: 'bold',
                      marginTop: '.8em',
                    }}
                  >
                    Veri İndirme
                  </Typography>
                </Stack>
                <InputLabel id="selectDownLayer">Veri Katmanı</InputLabel>
                <Select
                  labelId="selectDownLayer"
                  id="selectDownLayer"
                  value={downloadLayer}
                  label="Format"
                  onChange={handleLayer}
                >
                  {layerFeatureList.map((layer, index) => {
                    return (
                      <MenuItem key={index} value={layer.get('title')}>
                        {layer.get('title')}
                      </MenuItem>
                    );
                  })}
                </Select>
                <FormHelperText>
                  İndirmek istediğiniz katmanı seçiniz
                </FormHelperText>
                <ButtonGroup
                  disabled={!layerFeatureList.length}
                  variant="outlined"
                  aria-label="outlined primary button group"
                >
                  <Tooltip title="EsriJSON">
                    <span>
                      <Button onClick={() => downloadFile('EsriJSON')}>
                        <i className="fg-esri-json-file fg-2x"></i>
                      </Button>
                    </span>
                  </Tooltip>
                  <Tooltip title="GeoJSON">
                    <span>
                      <Button onClick={() => downloadFile('GeoJSON')}>
                        <i className="fg-geojson-file fg-2x"></i>
                      </Button>
                    </span>
                  </Tooltip>
                  <Tooltip title="GPX">
                    <span>
                      <Button onClick={() => downloadFile('GPX')}>
                        <i className="fg-gpx-file fg-2x"></i>
                      </Button>
                    </span>
                  </Tooltip>
                  <Tooltip title="KML">
                    <span>
                      <Button onClick={() => downloadFile('KML')}>
                        <i className="fg-kml-file fg-2x"></i>
                      </Button>
                    </span>
                  </Tooltip>
                  <Tooltip title="ShapeFile">
                    <span>
                      <Button onClick={() => downloadFile('ShapeFile')}>
                        <i className="fg-shape-file fg-2x"></i>
                      </Button>
                    </span>
                  </Tooltip>
                  <Tooltip title="TopoJSON">
                    <span>
                      <Button onClick={() => downloadFile('TopoJSON')}>
                        <i className="fg-topojson-file fg-2x"></i>
                      </Button>
                    </span>
                  </Tooltip>
                </ButtonGroup>
                <FormHelperText id="my-helper-text2">
                  İndirmek istediğiniz dosya formatını seçiniz
                </FormHelperText>
              </Stack>
            </Stack>
          </FormGroup>
        </CardContent>
        <CardActions></CardActions>
      </Card>
    </Draggable>
  );
};

export default DataImpExpUtil;
